import { Box } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import React from "react";
import CcIconButton from "../mui/CcIconButton";

/**
 * Standard edit/delete actions for CcDataTable action columns.
 * Matches the Medications tab table pattern.
 */
const CcDataTableEditDeleteActions = ({
  onEdit,
  onDelete,
  editLabel = "Edit",
  deleteLabel = "Delete",
}) => (
  <Box
    display="inline-flex"
    alignItems="center"
    style={{ gap: 6 }}
    onClick={(event) => event.stopPropagation()}
  >
    <CcIconButton
      label={editLabel}
      size="sm"
      variant="secondary"
      onClick={onEdit}
    >
      <EditOutlinedIcon />
    </CcIconButton>
    <CcIconButton
      label={deleteLabel}
      size="sm"
      variant="danger"
      onClick={onDelete}
    >
      <DeleteOutlineIcon />
    </CcIconButton>
  </Box>
);

export default CcDataTableEditDeleteActions;
